var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("div", { staticClass: "form-group" }, [
      _c("label", { attrs: { for: "email" + _vm._uid } }, [
        _vm._v(_vm._s(_vm.$t("duty.cbm.email")))
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.email,
            expression: "email"
          }
        ],
        staticClass: "form-control",
        attrs: { type: "email", id: "email" + _vm._uid, disabled: _vm.saved },
        domProps: { value: _vm.email },
        on: {
          input: function($event) {
            if ($event.target.composing) return
            _vm.email = $event.target.value
          }
        }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("label", { attrs: { for: "comment" + _vm._uid } }, [
        _vm._v(_vm._s(_vm.$t("duty.cbm.comment")))
      ]),
      _vm._v(" "),
      _c("textarea", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.comment,
            expression: "comment"
          }
        ],
        staticClass: "form-control",
        attrs: { type: "email", id: "comment" + _vm._uid, disabled: _vm.saved },
        domProps: { value: _vm.comment },
        on: {
          input: function($event) {
            if ($event.target.composing) return
            _vm.comment = $event.target.value
          }
        }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "d-flex" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-primary ml-auto",
          attrs: { disabled: _vm.saved },
          on: { click: _vm.trigger }
        },
        [_vm._v(_vm._s(_vm.$t("duty.cbm.trigger")))]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }